import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const FIND_SPOTS_REQUEST = 'FIND_SPOTS_REQUEST';

export const findSpotsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings ) => ({
    type: FIND_SPOTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
